export class FindAllDefaultRolesError {
  public static readonly type =
    '[Organisation/OrganisationRoles/List] FindAllDefaultRolesError';
  constructor(public readonly error: Error) {}
}
